// tslint:disable: no-unused-expression
import { Component, OnInit, OnChanges, OnDestroy, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

import { GetCurrentThemeService } from 'src/app/services/TemplateServices/get-current-theme.service';
import { SharedFunctionsService } from 'src/app/services/TemplateServices/shared-functions.service';

import { DataSet, Node, Color, Edge } from 'vis';

import { ColorConverterPipe } from 'src/app/pipes/color-converter.pipe';

import { RouteStructure, ErrorStructure, RouteNodeStructure } from 'src/app/interfaces/management';

declare var vis: any;

@Component({
  templateUrl: './route-neural-network.component.html',
  styleUrls: ['./route-neural-network.component.scss'],
  selector: 'app-route-neural-network',
})
export class RouteNeuralNetworkComponent implements OnInit, OnChanges, OnDestroy {

  // themeSubscriber: Recibe cambios del servicio de temas
  themeSubscriber: Subscription = new Subscription();

  // nodes: Nodos de la gráfica
  nodes: vis.DataSet<vis.Node>;
  // edges: Ejes de la gráfica
  edges: vis.DataSet<vis.Edge>;
  // network: Instancia de a gráfica
  network: vis.Network;
  // options: Opciones de la gráfica
  options: vis.Options;
  // data: Nodos y ejes de la gráfica
  data: vis.Data;

  // filterRoutes: Rutas en jerarquía
  routeList: { [routeIndex: string]: RouteStructure[] } = {};
  // routes: Información de las rutas
  routes: (RouteStructure & RouteNodeStructure)[];
  // selectedRoutes: Histórico de rutas seleccionadas
  selectedRoutes: string[] = [];

  // activate: Emisor que agrupa todos los eventos que se pueden devolver al usuario
  @Output() activate: EventEmitter<{ [event: string]: Subject<any> }> = new EventEmitter();
  routeListChange: Subject<{ [routeIndex: string]: RouteStructure[] }> = new Subject();
  routesChange: Subject<(RouteStructure & RouteNodeStructure)[]> = new Subject();
  click: Subject<RouteStructure[]> = new Subject();
  // instanceId: Id único de la instancia del componente
  instanceId: string;

  // removeRoute: Ruta a eliminar
  @Input() removeRoute: RouteStructure[];
  // nodeList: Listado de rutas
  @Input() nodeList: RouteStructure[];
  // editable: Se añaden los nodos para agregar nodos
  @Input() editable = true;
  // ghostRoutes: Se añaden las rutas constantes
  @Input() ghostRoutes: { [nodeId: string]: { show: boolean, disabled: boolean } } = {
    0: { show: true, disabled: false },
    "-1": { show: true, disabled: false },
    "-2": { show: true, disabled: false },
    "-3": { show: true, disabled: false },
    "-4": { show: true, disabled: false }
  };

  constructor(
    private sharedMethods: SharedFunctionsService,
    private colorConverter: ColorConverterPipe,
    private theme: GetCurrentThemeService,
  ) {
    // ↓ Aisgna el id
    this.instanceId = this.sharedMethods.generateHexString(8);
    // ↓ Suscripción a cambio de tema
    this.themeSubscriber = this.theme.emitter.subscribe(() => {
      // ↓ Obtiene todos los nodos
      const nodes: Node[] = (this.data.nodes as DataSet<Node>).get();
      // ↓ Actualiza el color de los nodos
      nodes.forEach((elm: Node) => {
        const el = this.routes.filter((e: RouteStructure) => e.id === elm.id);
        (elm.color as Color).border = this.theme.themeGroups[el[0].lvl];
        elm.image = this.setLabelDescription(el[0]);
        this.nodes.update(elm);
      });
    });
  }

  ngOnInit() {
    // ↓ Comparte la suscripción al evento
    this.activate.emit({
      routeList: this.routeListChange,
      routes: this.routesChange,
      click: this.click,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.removeRoute && changes.removeRoute.currentValue) {
        this.deleteNode(changes.removeRoute.currentValue);
      }
      if (changes.nodeList && changes.nodeList.currentValue) {
        this.setNeutalNetwork(changes.nodeList.currentValue);
      }
      if (changes.ghostRoutes && changes.ghostRoutes.currentValue) {
        this.setNeutalNetwork(this.nodeList);
      }
    }
  }

  /* setNeutalNetwork(): Método que genera la red neuronal con la información de las rutas
    data: Listado de rutas
  */
  setNeutalNetwork = (data: (RouteStructure & RouteNodeStructure)[] | ErrorStructure) => {
    if (!((data as ErrorStructure).requestStatus === false)) {
      // ghostRoutes: Rutas constantes
      const ghostRoutes: (RouteStructure & RouteNodeStructure)[] = [];
      // ↓^5 Añade las rutas constantes
      if (this.ghostRoutes["0"].show) { ghostRoutes.push({ id: "0", parent: "0", orden: "-1", descripcion: "Inicio", router_link: null, disabled: this.ghostRoutes["0"].disabled }); }
      if (this.ghostRoutes["-1"].show) { ghostRoutes.push({ id: "-1", parent: "-1", orden: "0", descripcion: "Entidades", router_link: null, disabled: this.ghostRoutes["-1"].disabled }); }
      if (this.ghostRoutes["-2"].show) { ghostRoutes.push({ id: "-2", parent: "0", orden: "-1", descripcion: "Reportes", router_link: null, disabled: this.ghostRoutes["-2"].disabled }); }
      if (this.ghostRoutes["-3"].show) { ghostRoutes.push({ id: "-3", parent: "0", orden: "0", descripcion: "Gestión Indicadores", router_link: null, disabled: this.ghostRoutes["-3"].disabled }); }
      if (this.ghostRoutes["-4"].show) { ghostRoutes.push({ id: "-4", parent: "-4", orden: "3", descripcion: "Pendientes Por Asignar", router_link: null, disabled: this.ghostRoutes["-4"].disabled }); }
      // ↓ Une las rutas constantes y las rutas de BD
      data = [...ghostRoutes, ...(data as [])];
      // ↓ Complementa la información de las rutas
      data.filter((elm: RouteStructure) => `${elm.id}` === `${elm.parent}`).forEach((elm: RouteStructure & RouteNodeStructure) => {
        const idx: number = (data as []).findIndex((el: RouteStructure) => `${elm.id}` === `${el.id}`);
        if (this.editable) { (data as (RouteStructure & RouteNodeStructure)[]).splice(idx, 0, { id: `new${elm.id}`, descripcion: "Agregar", parent: elm.id, level: 1, lvl: 1 }); }
        [elm.level, elm.lvl] = [0, 0];
        data = this.getLvl(data as [], `${elm.id}`);
      });
      // ↓ Filtra las rutas validas
      data = data.filter((elm: RouteNodeStructure) => ![null, undefined].includes(elm.level));
      // ↓ Asigna globalmente el valor final de las rutas
      this.routes = data;
      // ↓ Comparte información a los componentes
      setTimeout(() => (this.routesChange.next(data as [])), 1);
      // ↓↓ Obtiene los hijos de cada ruta
      this.routeList.gc_balanced = this.getChilds(null);
      this.routes.forEach((elm: RouteStructure) => this.routeList[elm.id] = this.getChilds(elm.id));
      // ↓ Comparte información a los componentes
      setTimeout(() => (this.routeListChange.next(this.routeList)), 1);
      // create an array with nodes
      this.nodes = new vis.DataSet((data as []).map((elm: RouteStructure & RouteNodeStructure) => ({
        image: this.setLabelDescription(elm), id: elm.id, shape: "image", shapeProperties: { borderRadius: 0 }, level: elm.level, fixed: true, color: { border: this.theme.themeGroups[elm.lvl] }
      })));
      // create an array with edges
      this.edges = new vis.DataSet((data as []).filter((elm: RouteStructure) => elm.id !== elm.parent).map((elm: RouteStructure) => ({
        from: elm.id, to: elm.parent, arrows: "from", width: 3, selectionWidth: 3, hoverWidth: 1.5, color: { opacity: 1 }
      })));

      this.data = { nodes: this.nodes, edges: this.edges };
      this.options = {
        edges: { smooth: { forceDirection: 'horizontal', type: 'cubicBezier', roundness: 0.4, enabled: true, } },
        layout: { hierarchical: { direction: 'UD' } },
        physics: false
      };
      // ↓ Verifica que la red no se haya creado
      if (!this.network) {
        // startNetwork: Función que inicia la red y sus eventos
        const startNetwork: () => void = () => {
          const container: HTMLElement = document.querySelector(`#neural-network${this.instanceId}`);
          if (container) {
            this.network = new vis.Network(container, this.data, this.options);
            this.network.on("click", (event: any) => {
              // ↓ Verifica que se haya hecho click en un nodo
              if ((event.nodes as string[]).length > 0) {
                (event.nodes as string[]).forEach((elm: string) => {
                  if (this.routes.filter((el: RouteStructure) => el.id === elm).length > 0) {
                    // ↓ nodeData: Opciones del nodo
                    const nodeData: RouteStructure = this.routes.filter((el: RouteStructure) => el.id === elm)[0];
                    // ↓ nodeParent: Opciones del padre
                    const nodeParent: RouteStructure = nodeData.parent && (`${nodeData.parent}` !== `${nodeData.id}`) ? (this.routes.filter((el: RouteStructure) => el.id === nodeData.parent)[0]) : null;
                    this.click.next([nodeData, nodeParent]);
                  }
                });
              }
            });
          } else { setTimeout(() => startNetwork(), 100); }
          // ↑ Reinicia la función si no se encuentra el contenedor en el dom
        };
        startNetwork();
      } else {
        // ↓ Actualiza la información de la red
        this.network.setData({ nodes: this.nodes, edges: this.edges });
        // ↓ Actualiza la información de los grupos
        if (this.selectedRoutes.length > 0) {
          this.showGroup(false, this.selectedRoutes[this.selectedRoutes.length - 1]);
        }
      }

    } else { M.toast({ html: "Imposible cargar las rutas", classes: "background-danger white-text" }); }
  }

  /* getLvl(): Método que devuelve el nivel al que pertenece un nodo
    nodes: Información de los nodos
    filter: Nodo padre
    lvl: Nivel del hijo
  */
  getLvl(nodes: (RouteStructure & RouteNodeStructure)[], filter: string, lvl = 1, level = 1): (RouteStructure & RouteNodeStructure)[] {
    const parent: RouteStructure = nodes.filter((elm: RouteStructure) => `${elm.id}` === filter)[0];
    // filterNodes: Obtiene los hijos de la ruta
    const filterNodes: (RouteStructure & RouteNodeStructure)[] = nodes.filter((elm: RouteStructure & RouteNodeStructure) => `${elm.parent}` === filter && `${elm.parent}` !== `${elm.id}` && [null, undefined].includes(elm.level));
    // ↓ Asigna los niveles y el grupo al que pertenecen los nodos
    filterNodes.forEach((elm: RouteStructure, index: number) => {
      const times: number = (filterNodes.length / 4) === Math.floor(filterNodes.length / 4) ? (filterNodes.length / 4) : Math.floor(filterNodes.length / 4) + 1;
      const groups: number = (Math.ceil(filterNodes.length / times));
      filterNodes[index].level = level + (Math.floor(index / groups));
      filterNodes[index].lvl = lvl;
      nodes = this.getLvl(nodes, `${elm.id}`, lvl + 1, level + times);
    });
    // ↓ Verifica si la ruta tiene hijos
    if (this.editable && parent.id !== parent.parent && !parent.router_link) {
      const idx: number = nodes.findIndex((elm: RouteStructure) => `${elm.id}` === filter);
      nodes.splice(idx, 0, { id: `new${filter}`, descripcion: "Agregar", parent: filter, level, lvl });
    }
    return nodes;
  }

  /* setLabelDescription(): Método que devuelve el texto a mostrar en el nodo
    title: Información del nodo
  */
  setLabelDescription(elm: RouteStructure & RouteNodeStructure): string {
    const background: string = elm.disabled ? "#cccccc" : this.theme.themeGroups[elm.lvl];
    switch (elm.descripcion) {
      case "Agregar":
        const text = `<div style="padding: 0px; height: 75px; display: flex; align-items: center; justify-content: center; overflow: hidden;">
          <p style="text-align: center; font-size: 75px; margin: 0; padding: 0; font-weight: 700;">+</p>
        </div>`;
        return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="75" height="75">
          <path d="M 0 37.5 a 1,1 0 1,1 75,0 a 1,1 0 1,1 -75 0z" fill="${this.colorConverter.pSBC(-0.5, background)}" />
          <path d="M 2.5 35 a 1,1 0 1,1 70,5 a 1,1 0 1,1 -70 -5z" fill="${this.theme.themeValues.backgroundForSections}" />
          <foreignObject x="0" y="0" width="100%" height="100%" color="${this.colorConverter.pSBC(-0.5, background)}">
            <div xmlns="http://www.w3.org/1999/xhtml" style="font-family: Arial">
              ${text}
            </div>
          </foreignObject>
        </svg>`);
      default:
        const description = `<div style="padding: 5px; height: 75px; display: flex; align-items: center; justify-content: center; overflow: hidden;">
          <p style='text-align: center; font-size: 14px; margin-top: 0; padding: 0; font-weight: 700;'>${elm.descripcion.replace("&", " y ")}</p>
        </div>`;
        // ↓ Devuelve el texto formateado en svg
        return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="150" height="75">
          <path d="M0 15 Q0 0 15 0 H135 Q150 0 150 15 V60 Q150 75 135 75 H15 Q0 75 0 60 V15z" fill="${this.colorConverter.pSBC(-0.5, background)}"/>
          <path d="M2 17 Q2 2 17 2 H133 Q148 2 148 17 V58 Q148 73 133 73 H17 Q2 73 2 58 V17z" fill="${background}"/>
          <foreignObject x="0" y="0" width="100%" height="100%" color="${this.theme.themeValues.textColorOverBackground}">
            <div xmlns="http://www.w3.org/1999/xhtml" style="font-family: Arial">
              ${description}
            </div>
          </foreignObject>
        </svg>`);
    }

  }

  /* showGroup(): Método que activa el grupo seleccionado en la red
    group: Grupo a mostrar
  */
  showGroup(animations: boolean, group: string, reload?: number) {
    reload >= 0 ? (this.selectedRoutes = this.selectedRoutes.slice(0, reload)) : (this.selectedRoutes.includes(group) ? null : this.selectedRoutes.push(group));
    // ↓ Obtiene la familia de rutas
    const elms: string[] = this.getFamily(group);
    // nodes, edges Obtiene todos los nodos y ejes
    const nodes: Node[] = (this.data.nodes as DataSet<Node>).get();
    const edges: Node[] = (this.data.edges as DataSet<Edge>).get();
    // ↓↓ Actualiza la opacidad de los nodos y ejes
    this.nodes.update(nodes.map((elm: Node) => ((elm as { opacity }).opacity = (elms.includes(`${elm.id}`) ? 1 : 0.5), elm)));
    this.edges.update(edges.map((elm: Edge) => ((elm.color as { opacity }).opacity = elms.includes(`${elm.from}`) ? 1 : 0.1, elm)));
    // ↓ Actualiza la visión de la gráfica
    this.network.fit({ nodes: elms, animation: animations });
  }

  /* getFamily(): Obtiene la familia descendente de una ruta
    id: Ruta padre
    family: Listado de familiares
  */
  getFamily(id: string, family: string[] = []): string[] {
    // ↓ Añade la ruta a la familia
    id ? family.push(id) : null;
    // ↓ Busca hijos de la ruta
    this.routes.filter((elm: RouteStructure) => id !== null ? (elm.parent === id && `${elm.parent}` !== `${elm.id}`) : true).forEach((elm: RouteStructure) => this.getFamily(elm.id, family));
    return family;
  }

  /* getChilds(): Obtiene los hijos de una ruta
    id: Ruta padre
  */
  getChilds = (id: string): RouteStructure[] => this.routes.filter((elm: RouteStructure) => id !== null ? (elm.parent === id && elm.parent !== elm.id) : (elm.parent === elm.id));

  /* deleteNode(): Método que elimina un nodo seleccionado en breadcrumbs
    nodeId: Id del nodo a eliminar
  */
  deleteNode(nodeId: string) {
    const idx: number = this.selectedRoutes.findIndex((elm) => elm === nodeId);
    if (idx !== -1) { this.selectedRoutes.splice(idx, 1); }
  }

  ngOnDestroy() {
    // ↓ Cancela la suscripción al servicio de temas
    this.themeSubscriber.unsubscribe();
    this.network.destroy();
  }

}
